import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { TippyModule } from '@ngneat/helipopper';

import { I18nModule } from '@app/i18n';
import { AuthModule } from '@app/auth';
import { ShellComponent } from './shell.component';
import { IconComponent, ThemeSwitchComponent } from '@shared/components/ui';
import { NotificationsComponent } from '@shared/components';
import { DefaultImageDirective, FetchProfileImageDirective } from '@shared/directives';
import { HumanizePipe } from '@shared/pipes';
import { HeaderComponent } from '@app/shell/web/header/header.component';
import { SidebarComponent } from '@app/shell/web/sidebar/sidebar.component';
import { TopBarComponent } from '@app/shell/mobile/topbar/topbar.component';
import { BottomNavigationComponent } from '@app/shell/mobile/bottom-navigation/bottom-navigation.component';
import { SideNavigationComponent } from '@app/shell/mobile/side-navigation/side-navigation.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    AuthModule,
    I18nModule,
    RouterModule,
    IconComponent,
    TippyModule,
    NotificationsComponent,
    FetchProfileImageDirective,
    HumanizePipe,
    DefaultImageDirective,
    FormsModule,
    ThemeSwitchComponent,
  ],
  declarations: [ShellComponent, HeaderComponent, SidebarComponent, TopBarComponent, BottomNavigationComponent, SideNavigationComponent],
  exports: [TopBarComponent],
})
export class ShellModule {}
